angular
  .module('fca-used')
  .component('accordionPanel', {
    templateUrl: 'app/accordion/accordion-panel.html',
    controller: accordionPanelController,
    controllerAs: 'accordionPanel',
    transclude: {
      header: 'panelHeader',
      content: 'panelContent'
    },
    bindings: {
      open: '<?',
      scrollOnToggle: '<?',
      afterPanelOpened: '&?'
    },
    require: {
      accordionController: '^?accordion'
    }
  });

accordionPanelController.$inject = ['$element', '$window', '$timeout', '$rootScope', 'scroll'];

function accordionPanelController($element, $window, $timeout, $rootScope, scroll) {
  var self = this;

  self.toggle = function (selector) {
    if (!self.open && self.scrollOnToggle) {
      $timeout(function () {
        self.scroll.to(selector);
        $rootScope.$broadcast('rzSliderForceRender');
        if (angular.isFunction(self.afterPanelOpened)) {
          self.afterPanelOpened();
        }
      }, 0);
    }
    self.accordionController.togglePanel(self);
  };

  self.$onInit = function () {
    self.scroll = scroll;
    if (self.accordionController) {
      self.accordionController.addPanel(self);
    }
  };
}
